<template>
  <div class="sp_privacyPolicy">
    <el-dialog title="Privacy Policy"
               :visible.sync="showDialog"
               class="privacy-policy"
               width="60%"
               :before-close="handleClose">
      <!-- <span>这是一段信息</span> -->
      <div class="content">
        <h2 class="title">Privacy Policy</h2>
        <p class="paragraph">SANGFOR attach great importance to the security of your Personal Data（as defined hereinafter） seriously.
          Collecting, using, storing of your personal data may be conducted upon you visit this www.xxx.com (“Sangfor Support Portal”) based on your consent,
          contract relationship or any applicable legal ground. This Privacy Policy represents how we collect, use, store your Personal Data as well as your
          legitimate rights to access, update, delete, and protect your Personal Data in relation to this Sangfor Support Portal.</p>
        <p class="paragraph">Considering Sangfor provides various kinds of products and services, this Privacy Policy may not cover all possible scenarios
          for personal data processing. Any specific data relating to the processing of personal data in the context of Sangfor’s products
          or services may be described in the privacy policy of related products or services, or may be released in any notice that is given
          during the collection of data.</p>
        <h4>YOU ARE REQUIRED TO GET FULLY UNDERSTANDING OF THIS PRIVACY POLICY BEFORE SUBMITTING YOUR PERSONAL DATA TO SANGFOR. BY USING THIS
          SANGFOR SUPPORT PORTAL, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD AND AGREE TO ALL OF THE TERMS OF THIS PRIVACY POLICY.</h4>
        <p class="paragraph">We use the following definitions in this Privacy Policy:</p>
        <ul>
          <li><span style="font-weight:600">“Sangfor”, “we”, “us”</span><span>means Sangfor Technologies Inc. and/or its affiliates.</span></li>
          <li><span style="font-weight:600">“Personal Data”</span><span>means any information relating to an identified or identifiable natural
              person (“data subject”); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference
              to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the
              physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.</span></li>
          <li><span style="font-weight:600">“You”</span><span>means the users of this Sangfor Support Portal.</span></li>
          <li><span style="font-weight:600">“Sangfor Support Portal”</span><span>means the service portal providing
              equipment activation application, maintenance management, renewal reminders, after-sales work orders and
              other service to the customer.</span></li>

        </ul>
        <h4>1.Collection and Use of Personal Data</h4>
        <h4>(1)Providing Sangfor Support Portal Service</h4>
        <p class="paragraph">Your Personal Data maybe be collected by your behavior of registering and managing relevant accounts, using this Sangfor Support Portal,
          or interacting with us. We may process the following personal data about you:</p>
        <h4>(i)Registration and Account Management</h4>
        <p class="paragraph">By using this Sangfor Support Portal, you need to register an account to enjoy certain functions or services. You can also use administrator
          account to add general account. When you register, add an account or log in this Sangfor Support Portal, we will ask you to provide the corresponding
          personal information, including:</p>
        <ul>
          <li>first name, last name, mobile/fix-line telephone number, e-mail address, company address, company name, country or region, industry type, etc.</li>
          <li>any information that you choose to share on this Sangfor Support Portal or when you contact us which may be considered Personal Data.</li>
        </ul>
        <h4>(ii)Equipment Activation and Maintenance Management</h4>
        <p class="paragraph">In order to assist you with equipment activation and maintenance management, we will collect your following device and service information from Sangfor Platform-X:</p>
        <ul>
          <li>device serial number, gateway/key ID, products name, products type, order number, license ID, license authority information, etc.</li>
        </ul>
        <p class="paragraph">If the Customer authorize the Partner to maintain their equipment, we will share the Your device and service information mentioned above with the Partner.</p>
        <h4>(iii) After-sales Work Orders Service</h4>
        <p class="paragraph">When you create a problem work order in Sangfor Support Portal, we will collect the relevant work order information from you and share the information with the
          colleagues providing technical services for you, including:</p>
        <ul>
          <li>company name, device serial number, gateway/key ID, contact person, mobile/fix-line telephone number, mailbox, etc.</li>
        </ul>
        <h4>(iv) Order management</h4>
        <p class="paragraph">After the Customer place an order, the Sangfor Support Portal will synchronize the service and item information to the Customer’s client interface to assist
          you with order management, including:</p>
        <ul>
          <li>device serial number, service or item name, service or item number, service write-off date, etc.</li>
        </ul>
        <p class="paragraph">We use your above Personal Data for the purposes of completing your registration for Sangfor Support Portal, and providing corresponding
          support portal service for you, including:</p>
        <ul>
          <li>Providing equipment activation service</li>
          <li>Providing products maintenance management service</li>
          <li>Providing renewal reminders service</li>
          <li>Providing after-sales work orders service</li>
          <li>Other service to you.</li>
        </ul>
        <h4>(2)Improving the Quality, Relevance, and Security of the System.</h4>
        <p class="paragraph">By using cookie and other similar technologies, this Sangfor Support Portal may indirectly record your personal data. When you use this Sangfor
          Support Portal, we may collect certain data automatically from your computers or devices (including mobile devices). The data we collect automatically
          may include:</p>
        <ul>
          <li>your IP address, device type, operating system, unique device identifiers, browser-type, browser language, geographic
            location and other technical information.</li>
          <li>the pages viewed, the links clicked, the amount of time spent on particular pages, mouse hovers, the date and time of
            the interaction, error logs, referring and exit pages and URLs, and similar information.</li>
        </ul>
        <p class="paragraph">We use this information only for our analytical purposes, and to improve the quality, relevance, and security of Sangfor Support Portal.</p>
        <p class="paragraph">Should the purposes of using your personal data are not included in this Privacy Policy, we will obtain your prior consent before we implementing the
          relevant purpose. Moreover, you are entitled to withdraw your consent at any time in compliance with the laws and regulations, but this maybe
          cause the function limitation of this Sangfor Support Portal.</p>
        <h4>2.Cookies and Other Similar Technologies</h4>
        <p class="paragraph">Like most sites, we use technologies that are essentially small data files placed on your computer, tablet, mobile phone, or other devices (referred
          to collectively as a "device") that allow us to record certain pieces of data whenever you visit or interact with this Sangfor
          Support Portal, and to recognize you across devices.</p>
        <p class="paragraph">The specific names and types of the cookies, unique identifiers, and similar technologies we use to collect data (e.g. about the pages you view,
          the links you click, and other actions you take on in this Sangfor Support Portal) may change from time to time. In order to help
          you better understand this Privacy Policy and our use of such technologies we have provided the following limited terminology and definitions:</p>
        <p class="paragraph">Cookies – Small text files (typically made up of letters and numbers) placed in the memory of your browser or device when you visit a website or
          view a message. Cookies allow a website to recognize a particular device or browser.</p>
        <p class="paragraph">Similar technologies – Technologies that store personal data in your browser or device utilizing local shared objects or local storage,
          such as flash cookies, HTML 5 cookies, and other web application software methods. These technologies can operate across all of your
          browsers, and in some instances may not be fully managed by your browser and may require management directly through your installed
          applications or device. We do not use these technologies for storing personal data to target advertising to you on or off our sites.</p>
        <p class="paragraph">We may use the terms "cookies" or "similar technologies" interchangeably in our policies to refer to all technologies that we may
          use to store data in your browser or device or that collect data or help us identify you in the manner described above.</p>
        <h4>3.Rights to Your Personal Data</h4>
        <p class="paragraph">If you submit your Personal Data to us, please ensure the accuracy of such data. If your Personal Data has changed
          (for instance, your mobile phone number has been changed), you are obliged to update your personal data in a timely manner.</p>
        <p class="paragraph">For requirements by applicable laws, you may: (1) have access to your Personal Data we have held; (2) update or correct any
          of your inaccurate Personal Data; (3) restrict or object to allow us to process your Personal Data; (4) require us to erasure
          your Personal Data;(5) require us to comply with your request for data portability; (6) withdraw your consent at any time which
          will not affect the lawfulness of processing based on consent before ;(7) lodge a complaint with the corresponding supervisory
          authority.</p>
        <p class="paragraph">When you claim the said rights, we may require you to submit a written request and may verify your identify. Usually,
          we do not charge anything for such processes unless your request goes beyond the limit of conventional requirements. </p>
        <h4>4.Sangfor Other Services Platforms</h4>
        <p class="paragraph">For the purpose of unified management of platform accounts and convenience of using Sangfor platform services, you are
          allowed to login in Sangfor skyOPS, Sangfor Community by using the account of Sangfor Support Portal. In this case,
          your Personal Data will be captured by those platforms, including your company name, region, type of user, account name,
          e-mail, etc. The use of Sangfor other service platforms is solely governed by the general terms and conditions (including
          the privacy policy) of the respective platform.</p>
        <h4>5.Protection and Storage of Personal Data</h4>
        <p class="paragraph">We recognize the need to ensure that personal information gathered via this Sangfor Support Portal remains secure.
          Sangfor Support Portal has security measures in place to protect against the loss, misuse, and alteration of the personal
          information under our control. Our security measures include the use of a hardware firewall to prevent unauthorized access,
          access control, allocate system privileges, data transmission and storage encryption, data backup on EU cloud server.
          You acknowledge that although we exercise adequate care and security, there remains a risk that information transmitted
          over the Internet and stored by computer may be intercepted or accessed by an unauthorized third-party. We will retain your
          information for the period necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period
          is required or permitted by law.</p>
        <h4>6.Breach Notification</h4>
        <p class="paragraph">In line with the GDPR, where a breach is known to have occurred which is likely to result in a risk to the rights and freedoms
          of individuals, the relevant Data Protection Authority (DPA) will be informed within 72 hours, unless the personal data breach
          is unlikely to result in a risk to the rights and freedoms of natural persons. Where the notification to the supervisory authority
          is not made within 72 hours, Sangfor inform the supervisory authority of the reasons for the delay. This will be managed in accordance
          with our Information Security Incident Response Procedure which sets out the overall process of handling information security incidents.</p>
        <h4>7.Update of this Privacy Policy</h4>
        <p class="paragraph">This Privacy Policy may be modified from time to time in line with legislation or industry developments. We therefore advise you to check
          this Privacy Policy regularly. Any material changes will be notified via this Sangfor Support Portal, email or other means we deem appropriate.</p>
        <h4>8.Contact Us</h4>
        <p class="paragraph">If you have any further question about this Privacy Policy, or have any request or query for your Personal Data, you can always contact
          us by e-mail: marketing@sangfor.com.</p>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="primary"
                   @click="confirm">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'privacyPolicy',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
      default: false,
    }
  },

  data () {
    return {

    }
  },

  methods: {
    handleClose () {
      this.$emit('updataDialogType', false)
    },
    confirm () {
      this.$emit('confirm', false)
    }
  },

  watch: {
    showDialog: {
      handler (val) {
        console.log(val);
      }
    },
    deep: true,
    immediate: true,
  }
}
</script>

<style lang="scss" scoped>
.privacy-policy {
  /deep/ .el-dialog {
    .el-dialog__header {
      background: #f2f2f2;
      border-bottom: 1px solid #ddd;
    }
    background: #fff;
    .el-dialog__body {
      max-height: 600px;
      overflow-y: auto;
      overflow-x: hidden;
      font-size: 14px;
    }
  }
}
.content {
  word-break: break-word !important;
  white-space: pre-wrap !important;
  .title {
    margin-bottom: 20px;
  }
  .paragraph {
    text-indent: 40px;
    display: block;
    margin-bottom: 20px !important;
  }
  h4 {
    margin: 10px 0 !important;
  }
}
</style>